import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import classes from "./Header.module.css";

function LowerHeader() {
  return (
    <div className={classes.lower_container}>
      <ul>
        <li>
          <GiHamburgerMenu />
          <p> All</p>
        </li>

        <li>
          <a href="">Today's Deals</a>
        </li>
        <li>
          <a href="">Gift Cards</a>
        </li>
        <li>
          <a href="">Sell</a>
        </li>
        <li>
          <a href="">Registry</a>
        </li>
        <li>
          <a href="">Prime Video</a>
        </li>
        <li>
          <a href="">Customer Service</a>
        </li>
      </ul>
    </div>
  );
}

export default LowerHeader;
